








import { defineComponent, onMounted, reactive, toRefs } from '@vue/composition-api';

export default defineComponent({
  name: 'bankConfirm',
  setup(props: any, { root }) {
    const state: any = reactive({
      banckInfo: null,
    });

    const getBankInfo = () => {
      state.banckInfo = JSON.parse((root.$route.query as any).data);
      gotoBankConfirm();
    };



    // 前往银行确认
    const gotoBankConfirm = () => {
      console.log('前往银行确认');

      // 招商银行发送请求，其他银行直接跳转
      const data = {
        'callpgid': 'scf_financeapplydetail',
        'cmisid': state.banckInfo.cmisId,
        'operatetype': 'jump_confirm',
      };
      (document.getElementById('banckTxtData') as any).value = JSON.stringify(data);
      (document.getElementById('banckConfirmForm') as any ).action = state.banckInfo.redirectUrl;
      (document.getElementById('banckConfirmForm') as any ).submit();
    };

    onMounted(getBankInfo);

    return {
      ...toRefs(state),
      gotoBankConfirm,
      getBankInfo,
    };
  },

  components: {

  },
});
